import React from 'react';
import { EntityListPageView, ErrorPage } from '@web-config-app/core-react-ui';
import {
  useResolvedEntity,
  useConfigAppParams,
  getEffectiveEntityId,
  EntityDetailsDataStoreProvider,
} from '@web-config-app/core-react';
import { EntityListPageContainer } from '@web-config-app/core-react-containers';

export const ConfigAppEntityListPage = () => {
  const params = useConfigAppParams();
  const { tabId, moduleId, childModuleId, environmentKey } = params;
  const effectiveEntityId = getEffectiveEntityId(params);
  const { entity: domainEntity, isError: isEntityError } = useResolvedEntity({
    entityId: effectiveEntityId,
  });

  if (isEntityError) {
    return <ErrorPage />;
  }

  // For tab-as-entity routes, moduleId is intentionally undefined — the
  // container/path helpers handle that nesting level correctly.
  const hasResources =
    !!domainEntity && !!tabId && !!effectiveEntityId && !!environmentKey;

  if (!hasResources) {
    return null;
  }

  return (
    <EntityDetailsDataStoreProvider>
      <EntityListPageContainer
        entityListPageContentsRenderer={EntityListPageView}
        domainEntity={domainEntity}
        tabId={tabId}
        moduleId={moduleId}
        childModuleId={childModuleId}
        environmentKey={environmentKey}
      />
    </EntityDetailsDataStoreProvider>
  );
};
